<div fxFlex fxLayoutAlign="center center">
	<mat-spinner
		*ngIf="utilService.isNullOrUndefined(usersList) && isLoadingUsersList"
		[diameter]="30"
	></mat-spinner>

	<div *ngIf="useSelect && !utilService.isNullOrUndefined(usersList) && !isLoadingUsersList" fxFlex>
		<div fxLayout="row" fxLayoutGap="1rem">
			<mat-form-field
				(click)="$event.stopPropagation()"
				[appearance]="appearance"
				[floatLabel]="floatLabel"
				class="{{ customCssClass }}"
				fxFlex
			>
				<mat-label>{{ placeholder }}</mat-label>
				<mat-select
					#userSelector
					[(ngModel)]="selectedUsers"
					[panelClass]="customePanelClass"
					disableOptionCentering
					multiple
				>
					<mat-option
						(click)="user.selected = !user.selected; changeOwner(user)"
						*ngFor="let user of usersList"
						[value]="user.userId"
					>
						{{ user.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div *ngIf="showAssignMe" class="{{ customAssignTexClass }}" fxLayout="row">
			<div (click)="setCurrentUser()" class="link">
				{{ assignText }}
			</div>
		</div>
	</div>

	<div
		*ngIf="useAutocomplete && !utilService.isNullOrUndefined(usersList) && !isLoadingUsersList"
		fxFlex
	>
		<mat-form-field
			(click)="$event.stopPropagation()"
			[appearance]="appearance"
			[floatLabel]="floatLabel"
			class="{{ customCssClass }}"
			fxFlex
		>
			<input
				(focus)="initializeList()"
				[formControl]="userCtrl"
				[matAutocomplete]="auto"
				[placeholder]="placeholder"
				class="capitalize"
				matInput
			/>
			<mat-icon *ngIf="showInputWithIcon" class="vertical-align-middle" matSuffix
				>keyboard_arrow_down</mat-icon
			>
			<mat-autocomplete
				#auto="matAutocomplete"
				(optionSelected)="selected($event)"
				[displayWith]="displayFn"
			>
				<mat-option *ngIf="isLoadingUsersList" fxLayoutAlign="center center">
					<mat-spinner *ngIf="isLoadingUsersList" [diameter]="30"></mat-spinner>
				</mat-option>

				<mat-option
					*ngIf="!isLoadingUsersList && filteredUsers.length == 0 && selectedUsers.length == 0"
				>
					<span> No matching user found </span>
				</mat-option>

				<ng-container *ngIf="!isLoadingUsersList">
					<mat-option *ngFor="let user of filteredUsers" [value]="user" class="capitalize">
						{{ user.name }}
					</mat-option>
				</ng-container>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>
